/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import ClientDownload from '../components/common/ClientDownload'

const PublicClientDownload: FC = () => {
  const { t } = useTranslation()

  const style = {
    backgroundColor: "#ecf0f5",
    position: "relative",
    margin: "30px 60px",
    borderRadius: "6px",
    padding: "24px",
  }

  return (
    <div className="public-client-download">
      <Helmet>
        <title>Qasee - client_download(public)</title>
      </Helmet>
      <div className="content-wrapper">
        <section
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "40px 60px 0 60px",
          }}
        >
          <h1
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "28px",
            }}
          >
            {t('client.download.title')}
          </h1>
        </section>
        <ClientDownload
          style={style}
        />
      </div>
    </div>
  )
}

export default PublicClientDownload
